(function () {
  function formatTime(value) {
    if (!Number.isFinite(value) || value < 0) return '--:--';
    var minutes = Math.floor(value / 60);
    var seconds = Math.floor(value % 60);
    return minutes + ':' + String(seconds).padStart(2, '0');
  }

  function initPlayer(root) {
    if (!root || root.dataset.audioInitialized === 'true') return;

    var audio = root.querySelector('[data-audio-element]');
    var toggle = root.querySelector('[data-audio-toggle]');
    var progress = root.querySelector('[data-audio-progress]');
    var time = root.querySelector('[data-audio-time]');
    var status = root.querySelector('[data-audio-status]');
    var speed = root.querySelector('[data-audio-speed]');
    var autoplayNext = root.querySelector('[data-audio-autoplay-next]');
    var bars = Array.prototype.slice.call(root.querySelectorAll('[data-audio-wave] span'));

    if (!audio || !toggle || !progress || !time) return;
    root.dataset.audioInitialized = 'true';
    root.dataset.state = 'paused';
    var trackedPlay = false;
    var trackedComplete = false;
    var trackedProgress = {};
    var playbackRates = [1, 1.25, 1.5, 2];
    var storedRate = Number(window.sessionStorage.getItem('csAudioPlaybackRate'));
    var currentRate = playbackRates.indexOf(storedRate) !== -1 ? storedRate : 1;
    var nextUrl = root.dataset.audioNextUrl || '';
    var declaredDuration = Number(root.dataset.audioDurationSeconds || 0);

    var labels = {
      play: root.dataset.labelPlay || 'Play',
      pause: root.dataset.labelPause || 'Pause',
      restart: root.dataset.labelRestart || 'Restart',
      loading: root.dataset.labelLoading || 'Loading',
      error: root.dataset.labelError || 'Audio unavailable',
      speed: root.dataset.labelSpeed || 'Playback speed',
      nextLoading: root.dataset.labelNextLoading || 'Opening the next article',
      autoplayBlocked: root.dataset.labelAutoplayBlocked || 'The next article is ready to play.'
    };

    function analyticsDetail(extra) {
      var duration = Number.isFinite(audio.duration) ? Math.round(audio.duration) : 0;
      var current = Number.isFinite(audio.currentTime) ? Math.round(audio.currentTime) : 0;
      return Object.assign({
        audio_product_id: root.dataset.audioProductId || '',
        audio_product_handle: root.dataset.audioProductHandle || '',
        audio_product_title: root.dataset.audioProductTitle || '',
        audio_locale: root.dataset.audioLocale || document.documentElement.lang || '',
        audio_page_type: root.dataset.audioPageType || '',
        audio_placement: root.dataset.audioPlacement || '',
        audio_duration_seconds: duration,
        audio_current_seconds: current
      }, extra || {});
    }

    function track(eventName, extra) {
      var detail = analyticsDetail(extra);
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push(Object.assign({ event: eventName }, detail));
      try {
        window.dispatchEvent(new CustomEvent('cs:analytics', {
          detail: Object.assign({ eventName: eventName }, detail)
        }));
      } catch (error) {
        // dataLayer tracking remains available in browsers without CustomEvent support.
      }
    }

    function setToggleLabel(label) {
      toggle.setAttribute('aria-label', label);
      toggle.setAttribute('title', label);
    }

    function setStatus(message) {
      status.textContent = message || '';
    }

    function renderSpeed() {
      if (!speed) return;
      speed.textContent = String(currentRate).replace('.0', '') + 'x';
      speed.setAttribute('aria-label', labels.speed + ': ' + speed.textContent);
      speed.setAttribute('title', labels.speed + ': ' + speed.textContent);
    }

    function setPlaybackRate(rate, shouldTrack) {
      currentRate = rate;
      audio.playbackRate = currentRate;
      window.sessionStorage.setItem('csAudioPlaybackRate', String(currentRate));
      renderSpeed();
      if (shouldTrack) track('cs_audio_playback_rate', { audio_playback_rate: currentRate });
    }

    function getPathname(url) {
      try {
        return new URL(url, window.location.origin).pathname;
      } catch (error) {
        return '';
      }
    }

    function continueWithNextArticle() {
      if (!nextUrl) return;
      window.sessionStorage.setItem('csAudioAutoplayNext', JSON.stringify({
        pathname: getPathname(nextUrl),
        requestedAt: Date.now()
      }));
      setStatus(labels.nextLoading);
      track('cs_audio_next_article', {
        audio_next_article_url: nextUrl,
        audio_next_article_title: root.dataset.audioNextTitle || ''
      });
      window.setTimeout(function () {
        window.location.assign(nextUrl);
      }, 250);
    }

    function renderProgress() {
      var duration = Number.isFinite(audio.duration) && audio.duration > 0 ? audio.duration : declaredDuration;
      var current = Number.isFinite(audio.currentTime) ? audio.currentTime : 0;
      var ratio = duration > 0 ? Math.min(1, Math.max(0, current / duration)) : 0;
      var percent = ratio * 100;

      progress.value = String(percent);
      progress.setAttribute(
        'aria-valuetext',
        formatTime(current) + ' / ' + formatTime(duration)
      );
      time.textContent = formatTime(current) + ' / ' + formatTime(duration);

      bars.forEach(function (bar, index) {
        bar.classList.toggle('is-filled', index / bars.length < ratio);
      });

      if (!audio.paused && !audio.ended) {
        [25, 50, 75].forEach(function (threshold) {
          if (percent >= threshold && !trackedProgress[threshold]) {
            trackedProgress[threshold] = true;
            track('cs_audio_progress', { audio_progress_percent: threshold });
          }
        });
      }
    }

    toggle.addEventListener('click', function () {
      if (audio.ended) audio.currentTime = 0;

      if (audio.paused) {
        document.querySelectorAll('[data-cs-product-audio] [data-audio-element]').forEach(function (otherAudio) {
          if (otherAudio !== audio && !otherAudio.paused) otherAudio.pause();
        });
        var playPromise = audio.play();
        if (playPromise && typeof playPromise.catch === 'function') {
          playPromise.catch(function () {
            root.dataset.state = 'paused';
            setToggleLabel(labels.play);
            setStatus(labels.error);
          });
        }
      } else {
        audio.pause();
      }
    });

    if (speed) {
      speed.addEventListener('click', function () {
        var currentIndex = playbackRates.indexOf(currentRate);
        var nextRate = playbackRates[(currentIndex + 1) % playbackRates.length];
        setPlaybackRate(nextRate, true);
      });
    }

    if (autoplayNext) {
      autoplayNext.addEventListener('change', function () {
        track('cs_audio_autoplay_next_toggle', {
          audio_autoplay_next: autoplayNext.checked,
          audio_next_article_url: nextUrl
        });
      });
    }

    progress.addEventListener('input', function () {
      if (!Number.isFinite(audio.duration) || audio.duration <= 0) return;
      audio.currentTime = (Number(progress.value) / 100) * audio.duration;
      renderProgress();
    });

    audio.addEventListener('loadedmetadata', renderProgress);
    audio.addEventListener('durationchange', renderProgress);
    audio.addEventListener('timeupdate', renderProgress);

    audio.addEventListener('play', function () {
      root.dataset.state = 'playing';
      root.dataset.hasStarted = 'true';
      setToggleLabel(labels.pause);
      setStatus('');
      if (!trackedPlay) {
        trackedPlay = true;
        track('cs_audio_play', { audio_progress_percent: 0 });
      }
    });

    audio.addEventListener('pause', function () {
      if (audio.ended) return;
      root.dataset.state = 'paused';
      setToggleLabel(labels.play);
    });

    audio.addEventListener('waiting', function () {
      setStatus(labels.loading);
    });

    audio.addEventListener('playing', function () {
      setStatus('');
    });

    audio.addEventListener('ended', function () {
      root.dataset.state = 'paused';
      setToggleLabel(labels.restart);
      renderProgress();
      if (!trackedComplete) {
        trackedComplete = true;
        track('cs_audio_complete', { audio_progress_percent: 100 });
      }
      if (autoplayNext && autoplayNext.checked && nextUrl) continueWithNextArticle();
    });

    audio.addEventListener('error', function () {
      root.dataset.state = 'paused';
      setToggleLabel(labels.play);
      setStatus(labels.error);
    });

    setPlaybackRate(currentRate, false);
    setToggleLabel(labels.play);
    renderProgress();
    // Some browsers defer metadata for offscreen media despite preload="metadata".
    // Explicitly loading the element makes the duration available before playback.
    audio.load();

    try {
      var savedAutoplay = JSON.parse(window.sessionStorage.getItem('csAudioAutoplayNext') || 'null');
      if (savedAutoplay && savedAutoplay.pathname === window.location.pathname) {
        window.sessionStorage.removeItem('csAudioAutoplayNext');
        var autoplayPromise = audio.play();
        if (autoplayPromise && typeof autoplayPromise.catch === 'function') {
          autoplayPromise.catch(function () {
            setStatus(labels.autoplayBlocked);
          });
        }
      }
    } catch (error) {
      window.sessionStorage.removeItem('csAudioAutoplayNext');
    }
  }

  function initAll(scope) {
    (scope || document).querySelectorAll('[data-cs-product-audio]').forEach(initPlayer);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll(document);
    }, { once: true });
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();
